// Единственная точка разбора серверного момента времени на дашборде.
//
// В БД время naive UTC, и наружу оно уезжает как UTC-инстант. Но суффикс есть не
// у всех форм: `new Date('2026-08-28T21:00:00')` без него парсится как **местное**
// время браузера, и весь график молча уезжает на разницу поясов. Поэтому голую
// строку помечаем UTC до разбора.
//
// Проверка суффикса якорится с конца и покрывает три формы, которые реально
// встречаются: `Z`, `+03:00` и `+03` (последнюю Postgres отдаёт для timestamptz —
// прежняя проверка требовала минуты и на ней ломалась).
const HAS_TZ = /(?:[zZ]|[+-]\d{2}(?::?\d{2})?)$/

/** Разбирает серверную метку времени, считая её UTC, если пояс не указан. */
export const parseServerInstant = (raw: unknown): Date => {
  const s = String(raw)
  return new Date(HAS_TZ.test(s) ? s : `${s}Z`)
}

/** Дата и время по МСК — для таблиц и подписей. */
export const formatMskDateTime = (raw: unknown): string =>
  parseServerInstant(raw).toLocaleString('ru-RU', { timeZone: 'Europe/Moscow' })

/** Только время по МСК — для ленты, где дата стоит в шапке точки. */
export const formatMskTime = (raw: unknown): string =>
  parseServerInstant(raw).toLocaleTimeString('ru-RU', {
    timeZone: 'Europe/Moscow',
    hour12: false,
  })
